import { spliceUrl, getAppTypeFromPath, APP_TYPE } from "@src/utils/common";

/**
 * @param {string} appId
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 * @description 获取版本列表
 */
export const getVersionList = (appId, type) => {
  const versionListUrl = {
    innerapp: `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/version/getVersions?appId=${appId}`,
    isv: `/${process.env.REACT_APP_API_CONTEXT}/service/isv/version/list?aliasName=${appId}`
  };
  return fetch(versionListUrl[type], { method: "GET" });
};

/**
 * @description 删除版本
 * @param {string} appId
 * @param {APP_TYPE.innerapp|APP_TYPE.isv} type
 */
export const deleteVersionList = (appId, type) => {
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/version?appId=${appId}&appType=${type}`,
    { method: "DELETE" }
  );
};

/**
 * @description 获取版本号
 * @param {string} appId
 * @param {string} versionName 版本号
 * @param {0|1} status 0：不对比信息，1：对比信息
 * @param {APP_TYPE.innerapp|APP_TYPE.isv} type
 */
export const versionDetail = (appId, versionName, status, type) => {
  let url = `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/version`;
  url = versionName
    ? spliceUrl(url, {
        appId,
        status,
        versionName,
        appType: type
      })
    : spliceUrl(url, { appId, status, appType: type });
  return fetch(url, { method: "GET" });
};

/**
 * @description 保存发布信息
 * @param {Object} params
 * @param {string} params.appId
 * @param {string} params.mobileCapability
 * @param {string} params.pcCapability
 * @param {string} params.updateDescribe
 * @param {string} params.versionName
 * @param {APP_TYPE.innerapp|APP_TYPE.isv} type
 * @returns
 */
export const saveVersion = (params, type) => {
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/version`,
    {
      method: "POST",
      body: JSON.stringify({
        ...params,
        appType: type
      })
    }
  );
};

/**
 * @description 撤回预审版本
 * @param {string} appId
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 */
export const undoAudit = (appId, type) => {
  const fetchFunc = {
    innerapp: () => {
      return fetch(
        `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/apps/${appId}/devversion/undoaudit`,
        { method: "POST" }
      );
    },
    isv: () => {
      return fetch(
        `/${process.env.REACT_APP_API_CONTEXT}/service/isv/version/preReview/cancel?aliasName=${appId}`,
        { method: "GET" }
      );
    }
  };
  return fetchFunc?.[type]?.();
};

// 获取企业管理员列表
export const getAdministrators = async (appId, keyword) => {
  const result = await fetch(
    `/${
      process.env.REACT_APP_API_CONTEXT
    }/service/isvVersion/getAdministrators/${appId}?keyword=${
      keyword ? keyword : ""
    }`,
    { method: "GET" }
  );
  return result;
};

// 发布
export const publishVersion = async (params, type) => {
  const result = await fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/version/publish?appId=${params.appId}`,
    {
      method: "POST",
      body: JSON.stringify(params)
    }
  );
  return result;
};

/**
 * @description 查询应用详情
 * @param {string} appId
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 */
export const getAppInfoList = async (appId, type) => {
  try {
    const appInfoUrl = {
      innerapp: "innerapp",
      isv: "isv/app"
    };
    let url = `/${process.env.REACT_APP_API_CONTEXT}/service/${appInfoUrl[type]}/${appId}`;
    return await fetch(url, { method: "GET" });
  } catch (error) {
    return null;
  }
};

// 第三方应用预览版提交上架预审核
export const submitPreAudit = async params => {
  const result = await fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/isv/version/pre-review/submit`,
    {
      method: "POST",
      body: params
    }
  );
  return result;
};

// 申请上架查询bindurl
export const getBindUrl = () => {
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/tenant/tenantInfo`,
    { method: "GET" }
  );
};


// 获取是否实名认证等基本信息
export const handleTenantInfo = async () => {
  const result = await fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/tenant/tenantInfo`,
    {
      method: "GET"
    }
  );
  return result;
};

